import { Send, Paperclip, X, FileText } from "lucide-react";
import { Avatar } from "../ui-bits";
import { API_BASE } from "../../lib/api";
import { cn } from "../../lib/utils";

export default function ChatComposer({ text, onTextChange, onSend, onUpload, uploading, pending, onRemovePending, mentionCandidates, onInsertMention, inputRef, testid }) {
  return (
    <>
      {pending.length > 0 && (
        <div className="flex flex-wrap gap-1.5 pt-2 shrink-0" data-testid={`${testid}-pending-attachments`}>
          {pending.map((a) => (
            <span key={a.id} className="flex items-center gap-1.5 text-xs border border-border rounded-md px-2 py-1 bg-muted/50">
              {a.content_type?.startsWith("image/")
                ? <img src={`${API_BASE}/files/${a.storage_path}`} alt="" className="h-6 w-6 rounded object-cover" />
                : <FileText size={12} className="text-[#E31E24]" />}
              <span className="max-w-[140px] truncate">{a.filename}</span>
              <button data-testid={`${testid}-pending-remove-${a.id}`} onClick={() => onRemovePending(a.id)}
                className="text-muted-foreground hover:text-[#E31E24] transition-colors"><X size={12} /></button>
            </span>
          ))}
        </div>
      )}

      <div className="relative pt-2 shrink-0">
        {mentionCandidates.length > 0 && (
          <div className="absolute bottom-full mb-1 left-0 w-64 bg-background border border-border rounded-md shadow-md z-50 py-1" data-testid={`${testid}-mention-menu`}>
            {mentionCandidates.map((u) => (
              <button key={u.id} data-testid={`${testid}-mention-${u.id}`} onClick={() => onInsertMention(u)}
                className="w-full flex items-center gap-2 px-2.5 py-1.5 hover:bg-muted text-sm">
                <Avatar name={u.name} userId={u.id} size="sm" online={u.online} />
                <span className="truncate">{u.name}</span>
              </button>
            ))}
          </div>
        )}
        <div className="flex items-center gap-1.5">
          <label data-testid={`${testid}-attach-label`} className={cn("h-9 w-9 flex items-center justify-center rounded-md border border-border text-muted-foreground hover:text-[#E31E24] hover:border-[#E31E24] transition-colors cursor-pointer shrink-0", uploading && "opacity-50 pointer-events-none")}>
            <Paperclip size={15} />
            <input data-testid={`${testid}-attach-input`} type="file" accept="image/*,application/pdf" multiple className="hidden" onChange={onUpload} disabled={uploading} />
          </label>
          <input ref={inputRef} data-testid={`${testid}-input`} value={text} onChange={onTextChange}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); onSend(); }
              if (e.key === "Escape") onTextChange({ target: { value: text, selectionStart: 0 }, escape: true });
            }}
            placeholder="Type a message… use @ to mention"
            className="flex-1 h-9 px-3 text-sm rounded-md border border-border bg-transparent focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary" />
          <button data-testid={`${testid}-send`} onClick={onSend}
            className="h-9 w-9 flex items-center justify-center rounded-md bg-[#E31E24] hover:bg-[#C81A1F] text-white transition-colors shrink-0">
            <Send size={15} />
          </button>
        </div>
      </div>
    </>
  );
}
